<template>
  <span></span>
</template>

<script>
export default {
  name: "Audio",
  props: {
    file: { type: String },
    slideNumber: { type: Number },
    updateFile: { type: Function }
  },
  data() {
    return {
      audio: null,
      currentSlide: null,
      newSlideNumber: null
    };
  },
  watch: {
    "$i18n.locale": function() {
      if (this.newSlideNumber === this.currentSlide) {
        this.audio.pause();
        this.audio.currentTime = 0;
        this.updateFile(this.currentSlide);
        this.audio = new Audio(this.file);
        this.audio.play();
      }
    },
    slideNumber(current) {
      this.newSlideNumber = current;
      if (current !== this.currentSlide) {
        this.audio.pause();
        this.audio.currentTime = 0;
      } else {
        this.audio = new Audio(this.file);
        this.audio.play();
      }
    }
  },
  mounted() {
    this.newSlideNumber = this.slideNumber;
    this.currentSlide = this.slideNumber;
    this.audio = new Audio(this.file);
    this.audio.play();
  }
};
</script>
